export enum DashboardCardTemplateTypeEnum {
  NUMERIC_COMPARISON = "NUMERIC_COMPARISON",
  PIE_CHART = "PIE_CHART",
  HORIZONTAL_BARS = "HORIZONTAL_BARS",
  VERTICAL_BARS = "VERTICAL_BARS",
  NONE = "NONE",
}
